import React from "react";
import PT from "prop-types";
import Avatar from "_c/Avatar";
import { useHistory } from "react-router";
import { LinkGenerator } from "@/utils/LinkGenerator";

const Placeholder = () => (
  <div
    css={`
      height: 30px;
    `}
  />
);
const ClientExcerpt = ({
  task,
  isTaskConsumer,
  isTaskMaster,
  openClientProfile,
}) => {
  const history = useHistory();
  let name, avatar, sex;
  if (isTaskConsumer) {
    name = task.master_meta?.name;
    avatar = task.master_meta?.avatar;
    sex = task.master_meta?.sex;
  } else {
    name = task.client_meta?.name;
    avatar = task.client_meta?.avatar;
    sex = task.client_meta?.sex;
  }
  if (!name) return <Placeholder />;
  const isClientProfileHidden = isTaskMaster && task.hide_client;

  const onClick = () => {
    if (isTaskConsumer) {
      history.push(LinkGenerator.masterProfile(task.master));
    } else if (!isClientProfileHidden) {
      openClientProfile();
    }
  };

  return (
    <div
      role="button"
      onClick={onClick}
      css={`
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        > span {
          margin-left: 7px;
        }
      `}
    >
      <Avatar
        size="sm"
        avatar={avatar}
        sex={sex}
        css={`
          display: flex;
        `}
        reverseColors
      />
      <span
        css={`
          @media (max-width: 400px) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 125px;
          }
        `}
      >
        {name}
      </span>
    </div>
  );
};

ClientExcerpt.propTypes = {
  task: PT.object.isRequired,
  isTaskConsumer: PT.bool.isRequired,
  isTaskMaster: PT.bool.isRequired,

  openClientProfile: PT.func.isRequired,
};

export default ClientExcerpt;
